import React from 'react'
import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import ViewWarehouseDeatil from './ViewWarehouseDeatil'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ViewWarehousemaster = () => {
      const location = useLocation();
  const warehouseData = location.state;
  return (
    // <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
    //     <Header/>
    //     <ViewWarehouseDeatil warehouseData={warehouseData}/>
    // </div>
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Warehouse - View</title>
			</Helmet>
            <Header/>
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
       <ViewWarehouseDeatil warehouseData={warehouseData}/>
            </div>
             </div>
  )
}

export default ViewWarehousemaster